import React from 'react';
import {View} from '@unthinkable/react-core-components';
import {
  TransitionalEventTable,
  HospitalizationDiagnose,
  HospitalizationMedication,
  PatientHeader,
} from '../components/index';
import {patientDetailStyles} from './style';
import {ContactAttempts} from '../components/ContactAttemptsTable';
import {useAuth} from '../../../modules/auth/hooks/useAuth';
import checkAuthorization from '../../../services/accessService';
import {action, entity} from '../../../constant/authorization';
import {TableHeader} from '../../../components/header/TableHeader';
import {TASK_TYPE} from '../../../constant/taskType';
import {useMediaQuery} from '../../../modules/auth/hooks/useMediaquery';
import CCDDocuments from '../components/CCDDocuments';
import {PatientEncounterDetailsStyle} from '../styles/PatientEncounterDetails.style';

export const PatientEncounterDetails = ({encounter, patient}) => {
  const {user} = useAuth();
  const latestEncounter = encounter;
  const taskInfo = latestEncounter?.taskInfo;
  const contactTaskDetail =
    taskInfo?.find(task => task.type === TASK_TYPE.ContactTask) || null;

  const {isMobile} = useMediaQuery();
  return (
    <View style={PatientEncounterDetailsStyle.container}>
      <PatientHeader patient={patient} encounter={latestEncounter} />
      {latestEncounter?.diagnoseReason && (
        <View
          style={
            isMobile
              ? patientDetailStyles.styles.column
              : patientDetailStyles.styles.row
          }>
          <TableHeader title={'Hospitalization Reason:'} />
          {latestEncounter?.diagnoseReason}
        </View>
      )}
      <View style={patientDetailStyles.styles.column}>
        <TransitionalEventTable patient={patient} encounter={latestEncounter} />
        <CCDDocuments encounter={latestEncounter} />
        <HospitalizationDiagnose encounter={latestEncounter} />
        <HospitalizationMedication
          encounter={latestEncounter}
          patient={patient}
        />
        {contactTaskDetail &&
          checkAuthorization(user, entity.ContactTask, action.view) && (
            <ContactAttempts
              taskId={contactTaskDetail.taskId}></ContactAttempts>
          )}
      </View>
    </View>
  );
};
